import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import SearchLayoutComponent from '../../../../../../core/layout-components/search';

export const ContainerAnswers = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0 20px 0;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 20px;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 20px;
  width: 100%;
`;

export const Title = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
  margin-top: 20px;
`;

export const QuestionOrder = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
`;

export const Search = styled(SearchLayoutComponent).attrs({
  isWritten: true,
})``;

export const Answer = styled.div`
  display: flex;
  padding: 10px 0;
`;

export const TesterName = styled.div`
  display: flex;
  width: 15%;
  font-weight: 500;
`;

export const WrittenResponse = styled.div`
  display: flex;
  flex: 1;
`;

export const NoResults = styled(TextLayoutComponent)`
  && {
    margin: 30px auto;
  }
`;
